import { resolveFillRateDifference } from '../../../poc/PurchaseOrder/helpers/fillRateMetrics'

export const getParentDifferenceAmount = (row) =>
  -resolveFillRateDifference(row)

export const getChildDifferenceAmount = (child) =>
  -resolveFillRateDifference(child, {
    purchaseOrderKey: 'total_oc',
    orderKey: 'total_pedido'
  })

export const hasParentDifference = (row) =>
  getParentDifferenceAmount(row) !== 0

export const hasChildDifference = (child) =>
  getChildDifferenceAmount(child) !== 0
